<template>
    <transition name="modal">
        <div class="modal-mask">
            <div class="notifications"
                 v-click-outside="props.closeModal"
            >
                <div class="notifications-header">
                    <h2>Notifications</h2>
                    <!-- <BIconX
                        icon="x"
                        class="closeIcon"
                        @click="props.closeModal"
                        data-testid="close-modal-button"
                        data-xpath="//*[@data-testid='close-modal-button']"
                    /> -->
                    <i class="bi bi-x closeIcon" 
                        icon="x"
                        @click="props.closeModal"
                        data-testid="close-modal-button"
                        data-xpath="//*[@data-testid='close-modal-button']" />
                </div>
                <div class="notifications-toolsWrapper">
                    <div class="notifications-tools">
                        <div
                            v-tooltip="{
                            content: 'Clear all'
                            }"
                            class="iconWrapper"
                            @click="handleDeleteAllNotifications"
                            data-testid="clear-all-button"
                            data-xpath="//*[@data-testid='clear-all-button']"
                        >
                            <i class="bi bi-trash" />
                        </div>
                        <div v-tooltip="{
                            content: snoozeTime
                            }"
                            :class="{
                            iconWrapper: true,
                            iconBorder: isSnoozeShow,
                            }"
                            @click="toggleSnoozeModal"
                            data-testid="snooze-modal-toggle"
                            data-xpath="//*[@data-testid='snooze-modal-toggle']"
                        >
                            <!-- <BIconBell v-bind:class="{snoozed: isSnoozed}" /> -->
                             <i class="bi bi-bell" v-bind:class="{snoozed: isSnoozed}" />
                        </div>
                        <SnoozeModal
                            v-if="isSnoozeShow"
                            v-click-outside="closeSnoozeModal"
                            v-bind:props="{
                                    closeModal: closeSnoozeModal,
                                }"
                        />
                        <span
                            v-if="notifications.length"
                            @click="handleReadAllNotifications"
                            data-testid="mark-all-read"
                            data-xpath="//*[@data-testid='mark-all-read']"
                        >
                       
                            Mark all as read
                        </span>
                    </div>
                </div>
                <div class="notifications-wrapper">
                    <div
                        v-for="(group, nameGroup) in groupedNotifications"
                        :key="nameGroup"
                        class="notifications-group"
                        :data-testid="`notification-group-${nameGroup}`"
                        :data-xpath="`//*[@data-testid='notification-group-${nameGroup}']`"
                    >
                        <div class="notifications-groupTitle">
                            <p>{{ nameGroup }}</p>
                        </div>
                        <div class="notifications-cards">
                            <NotificationCard
                                v-for="notification in group"
                                :key="notification.id"
                                v-bind:props="{
                                    subtitle: notification.title,
                                    type: notification.type,
                                    info: checkNotificationBody(notification),
                                    time: notification.created,
                                    viewed: notification.viewed,
                                    id: notification.id,
                                    externalId: notification.externalId,
                                    chatRoomId: notification.chatRoomId,
                                    closeModal: props.closeModal
                                }"
                                :data-testid="`notification-card-${notification.id}`"
                                :data-xpath="`//*[@data-testid='notification-card-${notification.id}']`"
                            />
                        </div>
                    </div>
                    <div class="my-no-results" style="text-align:center">
                        <span v-if="!notifications.length" data-testid="no-notifications">You have no notifications</span>
                    </div>
                    <VueEternalLoading :load="loadMore">
                        <template #no-results>
                            <div class="my-no-results">
                                <span data-testid="eternal-no-results">You have no notifications</span>
                            </div>
                        </template>
                        <template #no-more>
                            <div class="my-no-more" style="text-align:center">
                                <span v-if="notifications.length" data-testid="eternal-no-more">No more notifications</span>
                            </div>
                        </template>
                        <template #loading>
                            <div style="text-align:center">
                                <VueSpinnerTail
                                v-if="isLoading"
                                    :loading="true"
                                    color="grey"
                                    class="loader"
                                    size="20px"
                                    data-testid="eternal-loading"
                                    data-xpath="//*[@data-testid='eternal-loading']"
                                />
                            </div>
                        </template>
                    </VueEternalLoading>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import groupBy from 'lodash/groupBy';
import moment from 'moment';
// import {
//     BIconX,
//     BIconTrash,
//     BIconBell,
// } from 'bootstrap-vue-next'; 
import SnoozeModal from '@/redesign/Notifications/components/SnoozeModal.vue';
import { NotificationsTypesDB } from '../../constants/notifications';
import NotificationCard from './components/NotificationCard.vue';
import { getTimeOfDayNotification } from '../../helpers/getTimeOfDay';
import { VueEternalLoading, LoadAction} from '@ts-pro/vue-eternal-loading';
import  {VueSpinnerTail} from 'vue3-spinners';


export default {
    name: 'Notifications',
    components: {
        SnoozeModal,
        NotificationCard,
        // BIconX,
        // BIconTrash,
        // BIconBell,
        VueEternalLoading,
        VueSpinnerTail
    },
    props: {
        props: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            limit: 10,
            isLoading: false,
            isSnoozeShow: false,
            page: 1,
        };
    },
    created() {
        if (this.notifications.length) {
            this.loadNotifications(this.page);
        }
    },
    computed: {
        ...mapGetters(['notifications', 'account', 'allNotificationsCount', 'isLogged']),
        groupedNotifications() {
            return this.notifications
                ? groupBy(this.notifications, (v) => moment(v.created).fromNow())
                : [];
        },
        isSnoozed() {
            return moment(this.account.notDisturbDate).diff(moment()) > 0;
        },
        snoozeTime() {
            const time = moment(this.account.notDisturbDate).format('LLLL');
            return this.isSnoozed ? `Notifications disabled until ${time}` : 'Notifications are enabled';
        },
    },
    methods: {
        ...mapActions([
            'loadNotifications',
            'readAllNotifications',
            'deleteAllNotifications',
            'loadMoreNotifications'
        ]),
        loadMore(action) {
            this.isLoading = true;
            const skip = this.page++;
            const limit = 10;
            this.loadMoreNotifications(skip)
                .then(async () => {
                    if (this.allNotificationsCount == 0) {
                        action.noResults();
                    }
                   
                    if (!this.allNotificationsCount) {
                       
                        action.loaded(this.notifications.length, limit);
                    } else if (this.notifications.length < this.allNotificationsCount) {
                        
                        action.loaded(this.notifications.length, limit);
                    } else {
                        action.noMore();
                    }
                })
                .finally(() => {
                    this.isLoading = false;
                });

                this.isLoading = false;
        },
        toggleSnoozeModal() {
            this.isSnoozeShow = !this.isSnoozeShow;
        },
        closeSnoozeModal() {
            this.isSnoozeShow = false;
        },
        handleReadAllNotifications() {
            this.readAllNotifications()
                .then(() => {
                    this.loadNotifications();
                });
        },
        handleDeleteAllNotifications() {
            this.deleteAllNotifications()
                .then(() => {
                    this.loadNotifications();
                });
        },
        checkNotificationBody(notification) {
            const { job } = notification;
            if (!job) {
                return notification.body;
            }

            const formattedDate = moment(job.date).format('dddd Do MMMM');
            const { timeDay, durationTimeWork } = getTimeOfDayNotification(job);

            let infoEnding = '';

            switch (notification.type) {
                case NotificationsTypesDB.UPLIFT_APPROVED:
                    infoEnding = ' was approved.';
                    break;
                case NotificationsTypesDB.UPLIFT_CANCELLED:
                    infoEnding = ' was cancelled.';
                    break;
                case NotificationsTypesDB.UPLIFT_REJECTED:
                    infoEnding = ' was rejected.';
                    break;
                default:
                    break;
            }

            return `${notification.body}${formattedDate}, ${timeDay} ${durationTimeWork}${infoEnding}`;
        },
    },
};
</script>

<style scoped lang="scss">
    .modal-mask {
        position: fixed;
        z-index: 9998;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(25,26,50,.5);
        display: table;
        transition: opacity .3s ease;
    }

    .notifications {
        position: fixed;
        z-index: 9999;
        right: 0;
        top: 0;
        bottom: 0;
        width: 452px;
        background-color: white;
        display: flex;
        flex-direction: column;
        overflow: hidden;

        &-header {
            display: flex;
            height: 74px;
            border-bottom: 1px solid #D5E0E8;
            align-items: center;
            justify-content: space-between;
            padding: 0 20px 0 39px;

            h2 {
                font-family: "Source Sans Pro Light", sans-serif;
                font-size: 24px;
                margin: 0;
            }

            .closeIcon {
                width: 30px;
                height: 30px;
                cursor: pointer;
            }
        }

        &-toolsWrapper {
            height: 38px;
            border-bottom: 1px solid #D5E0E8;
        }

        &-tools {
            display: flex;
            justify-content: flex-end;

            .iconWrapper:active {
                border: 1px solid #52B8F6;
            }

            .iconWrapper {
                padding: 7px 6px 5px 7px;
                cursor: pointer;
                margin-right: 10px;

                img {
                    cursor: pointer;
                    height: 16px;
                    width: 16px;
                }

                .snoozed {
                    color: #F54E4E;
                }
            }

            .iconWrapper:hover {
                background-color: #F1F6FF;
            }

            .iconBorder {
                border: 1px solid #52B8F6;
            }

            span {
                color: #52B8F6;
                font-size: 14px;
                cursor: pointer;
                padding-right: 12px;
                position: absolute;
                z-index: 1000;
                top: 118px;
            }
        }

        &-wrapper {
            flex: 1 1 auto;
            overflow-y: auto;
            -webkit-overflow-scrolling: touch;
            height: calc(100vh - 112px); /* Subtracting header and tools height */
            position: relative;
            padding-bottom: 20px;
        }

        &-groupTitle {
            display: flex;
            position: sticky;
            z-index: 999;
            height: 32px;
            top: 0;
            justify-content: space-between;
            background-color: white;
            border-bottom: 1px solid #EFF1F5;
            align-items: center;

            p {
                color: #96B0D7;
                padding-left: 39px;
                text-transform: uppercase;
                font-size: 11px;
                margin: 0;
            }
        }

        .noResultsMessage {
            margin-top: 15px;
        }

    }
    .loader {
        position: relative;
        margin: 20px auto;
}
</style>
<style>
@import 'bootstrap-icons/font/bootstrap-icons.css';
</style>